var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-checkbox',_vm._g({attrs:{"checked":!!_vm.value},on:{"click":function($event){$event.stopPropagation();},"change":e => { _vm.$emit('input', e.target.checked); _vm.$emit('changeValue', e.target.checked) }}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }